<div *ngIf="isLoading" class="se-loader"></div>

<div class=" pb-5">
  <p-toast class="mt10" position="top-center" key="error"></p-toast>
  <div class=" hide-in-mobile">
    <div class="pdata">
      <div class="backbtn">
        <span id="pcontnet1" class="back_nav" routerLink='/dashboard' translate>
          &lt; {{ labels.btnBack | translate }}
        </span>
      </div>
      <label class="coolerName txt_label">
        {{this.labels.tableHeaderDevice|translate}} :
        <span *ngIf="isEditing" class="editor">
          <input type="text"
                 name="value" maxlength="29"
                 autofocus
                 [(ngModel)]="pendingDeviceName"
                 (keydown.Enter)="updateDeviceName()"
                 (keydown.Meta.Enter)="updateDeviceName()"
                 (focusout)="updateDeviceName()" />
        </span>
        <span *ngIf="(!isEditing)">
          {{this.deviceFullName}} <span class="fa fa-pencil-alt name-edit-icon" (click)="edit()"
                                        (keypress)="edit()"
                                        (keydown)="edit()"
                                        (keyup)="edit()"></span>
        </span>
      </label>



      <label class="coolerName txt_label">{{this.labels.tableHeaderDongleUId|translate}} : {{this.deviceDongleUId}}</label>
      <label class="controllerName txt_label">{{this.labels.commercialName|translate}}: {{this.commercial_name}}</label>
      <label class="firmwareVersion txt_label">{{this.labels.firmwareVersion|translate}}: {{this.firmwareVersion}}</label>
      <p id="pcontnet" class="txt_label">
        {{labels.lastConnectedOn | translate}}:&nbsp;{{last_connected_on | date:'dd/MM/yyyy HH:mm:ss'}}
      </p>
    </div>
  </div>
  <div class="hide-in-large">
    <div class="mobile-header">
      <div class="mobile-device-detail">
        <span id="pcontnet1" class="back_nav" routerLink='/dashboard'>
          &lt;
        </span>
        <span class="coolerName"> {{this.deviceFullName}}</span>

      </div>
      <div class="row  mobile-device-sub-detail">
        <div class="col">
          <p class="mobile-grid-header">{{labels.commercialName|translate}}</p>
          <p class="mobile-grid-data">{{this.commercial_name}}</p>
        </div>
        <div class="col">
          <p class="mobile-grid-header lastconnect-label">{{labels.lastConnectedOn | translate}}</p>
          <p class="device-last-connect">{{last_connected_on | date:'dd/MM/yyyy HH:mm:ss'}}</p>
        </div>
      </div>
    </div>
  </div>
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="dashboard-tabs nav-tabs grid-div-tabs">
    <li [ngbNavItem]="1">
      <a ngbNavLink>{{ labels.tabTitleTelemetry | translate }}</a>
      <ng-template ngbNavContent>
        <app-telemtry-data></app-telemtry-data>
      </ng-template>
    </li>
    <li [ngbNavItem]="2" *ngIf="isWireless && forExpo">
      <a ngbNavLink>{{ labels.tabTitleSettings | translate }}</a>
      <ng-template ngbNavContent>
        <app-telemetry-settings></app-telemetry-settings>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
